/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app_store_account: NonNullable<unknown> }} Dialog_Restore_Error_Forest_Account_ContentInputs */

const en_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your current ${i?.app_store_account} is already linked to another Forest Account.`)
};

const ar_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`حسابك الحالي ${i?.app_store_account} مرتبط بالفعل بحساب فورست آخر.`)
};

const de_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihre aktuelle ${i?.app_store_account} ist bereits mit einem anderen Forest-Konto verknüpft.`)
};

const es_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu ${i?.app_store_account} actual ya está vinculado a otra cuenta de Forest.`)
};

const fr_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre ${i?.app_store_account} actuel est déjà lié à un autre compte Forest.`)
};

const it_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo attuale ${i?.app_store_account} è già collegato a un altro account Forest.`)
};

const ja_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在の${i?.app_store_account}は、すでに別のForestアカウントとリンクしています。`)
};

const ko_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`현재 ${i?.app_store_account}은(는) 이미 다른 Forest 계정에 연결되어 있어요.`)
};

const pt_br_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua ${i?.app_store_account} atual já está vinculada a outra conta Forest.`)
};

const ru_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш текущий ${i?.app_store_account} уже привязан к другому аккаунту Forest.`)
};

const th_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app_store_account} ปัจจุบันของคุณถูกเชื่อมโยงกับบัญชี Forest อื่นอยู่แล้ว`)
};

const tr_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mevcut ${i?.app_store_account} başka bir Forest hesabına bağlı.`)
};

const zh_cn_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你当前的 ${i?.app_store_account} 已有 Plus 会员数据，绑定于其他 Forest 账号。`)
};

const zh_tw_dialog_restore_error_forest_account_content = /** @type {(inputs: Dialog_Restore_Error_Forest_Account_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你當前的 ${i?.app_store_account} 已有訂閱資料，綁定於其他 Forest 帳號。`)
};

/**
* | output |
* | --- |
* | "Your current {app_store_account} is already linked to another Forest Account." |
*
* @param {Dialog_Restore_Error_Forest_Account_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_error_forest_account_content = /** @type {((inputs: Dialog_Restore_Error_Forest_Account_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_Error_Forest_Account_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_error_forest_account_content(inputs)
	if (locale === "ar") return ar_dialog_restore_error_forest_account_content(inputs)
	if (locale === "de") return de_dialog_restore_error_forest_account_content(inputs)
	if (locale === "es") return es_dialog_restore_error_forest_account_content(inputs)
	if (locale === "fr") return fr_dialog_restore_error_forest_account_content(inputs)
	if (locale === "it") return it_dialog_restore_error_forest_account_content(inputs)
	if (locale === "ja") return ja_dialog_restore_error_forest_account_content(inputs)
	if (locale === "ko") return ko_dialog_restore_error_forest_account_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_error_forest_account_content(inputs)
	if (locale === "ru") return ru_dialog_restore_error_forest_account_content(inputs)
	if (locale === "th") return th_dialog_restore_error_forest_account_content(inputs)
	if (locale === "tr") return tr_dialog_restore_error_forest_account_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_error_forest_account_content(inputs)
	return zh_tw_dialog_restore_error_forest_account_content(inputs)
});